import {Ventrata} from 'types'

export const getUnitsPricing = (availability: Ventrata.Availability | undefined) => {
  if (!availability) {
    return null
  }

  if (availability.unitPricing && availability.unitPricing.length > 0) {
    return availability.unitPricing.reduce((result: Record<string, number>, unit) => {
      result[unit.unitId] = unit.retail || 0
      return result
    }, {})
  }

  return null
}
